import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { isConfigFlagEnabled } from '../config';
export const PanelContainer = styled.aside(({ padding }) => `
  width: 100%;
  padding: ${padding};
  display: flex;
  flex-direction: column;
  height: 100%;
  `);
export const COLUMN_LAYOUT_PANEL_CONTAINER_CSS = css `
  filter: drop-shadow(0 5px 3px rgba(0, 0, 0, 0.25));
`;
export const ROW_LAYOUT_PANEL_CONTAINER_CSS = css `
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.25));
`;
export const PANEL_CONTAINER_QUERY_CONTAINER_CLASS_NAME = isConfigFlagEnabled('panelContainerQueries')
    ? 'scaling-panel-container'
    : undefined;
